import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  Grid,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { QEStrategydataFlowContext } from "../../../main-pages/QEStrategyMainPage";
import QEStrategyCommonButton from "../qe-strategy-homepage/CommonButton";
import { usePrefillForm } from "../../../../utils/qe-strategy-utils/usePreFillForm";

const DevOpsTestAutoDeveloperExperience = ({ onBack, onNext }) => {
  // Selects
  const [devOpsMaturity, setDevOpsMaturity] = useState("");
  const [testsIntegrated, setTestsIntegrated] = useState("");

  // Radio Groups
  const [ciCdPipeline, setCiCdPipeline] = useState("");
  const [changeVelocity, setChangeVelocity] = useState("");
  const [testCoverage, setTestCoverage] = useState("");
  const [qualityGates, setQualityGates] = useState("");

  const [testEnv, setTestEnv] = useState("");
  const [pipelineFailures, setPipelineFailures] = useState("");
  const [discoverDebug, setDiscoverDebug] = useState("");
  const [testDataProvisioning, setTestDataProvisioning] = useState("");
  const [autoTestSuggestions, setAutoTestSuggestions] = useState("");
  const [qeIntegration, setQeIntegration] = useState("");
  const [selfServicePlatform, setSelfServicePlatform] = useState("");
  const [failedTestsAnalysis, setFailedTestsAnalysis] = useState("");

  const {
    devopsTestAutomationAndDeveloperExperience,
    setDevopsTestAutomationAndDeveloperExperience,
    dataFromFileUploads,
  } = useContext(QEStrategydataFlowContext);

  

  useEffect(() => {
    if (devopsTestAutomationAndDeveloperExperience) {
      setDevOpsMaturity(
        devopsTestAutomationAndDeveloperExperience.devOpsMaturity || ""
      );
      setTestsIntegrated(
        devopsTestAutomationAndDeveloperExperience.testsIntegrated || ""
      );

      // Radio Groups
      setCiCdPipeline(
        devopsTestAutomationAndDeveloperExperience.ciCdPipeline || ""
      );
      setChangeVelocity(
        devopsTestAutomationAndDeveloperExperience.changeVelocity || ""
      );
      setTestCoverage(
        devopsTestAutomationAndDeveloperExperience.testCoverage || ""
      );
      setQualityGates(
        devopsTestAutomationAndDeveloperExperience.qualityGates || ""
      );

      setTestEnv(devopsTestAutomationAndDeveloperExperience.testEnv || "");
      setPipelineFailures(
        devopsTestAutomationAndDeveloperExperience.pipelineFailures || ""
      );
      setDiscoverDebug(
        devopsTestAutomationAndDeveloperExperience.discoverDebug || ""
      );
      setTestDataProvisioning(
        devopsTestAutomationAndDeveloperExperience.testDataProvisioning || ""
      );
      setAutoTestSuggestions(
        devopsTestAutomationAndDeveloperExperience.autoTestSuggestions || ""
      );
      setQeIntegration(
        devopsTestAutomationAndDeveloperExperience.qeIntegration || ""
      );
      setSelfServicePlatform(
        devopsTestAutomationAndDeveloperExperience.selfServicePlatform || ""
      );
      setFailedTestsAnalysis(
        devopsTestAutomationAndDeveloperExperience.failedTestsAnalysis || ""
      );
    }
  }, [devopsTestAutomationAndDeveloperExperience]);

  const DevOpsTestAutomationAndDeveloperExperienceDataObject = {
    devOpsMaturity,
    ciCdPipeline,
    testsIntegrated,
    changeVelocity,
    testCoverage,
    qualityGates,
    testEnv,
    pipelineFailures,
    discoverDebug,
    testDataProvisioning,
    qeIntegration,
    autoTestSuggestions,
    selfServicePlatform,
    failedTestsAnalysis,
  };

  const [devOpsMaturityOptions, setDevOpsMaturityOptions] = useState([
    "None",
    "Basic",
    "Intermediate",
    "Advanced",
  ]);

  const [testsIntegratedOptions, setTestsIntegratedOptions] = useState([
    "0% (none)",
    "<30% (low integration)",
    "30–70% (moderate/partial)",
    ">70% (high integration)",
    "~100% (fully integrated)",
  ]);

  const questionToFieldMap = {
    "1. What is the current DevOps maturity level?": "devOpsMaturity",
    "2. Is a CI/CD pipeline in place?": "ciCdPipeline",
    "3. What is the typical change velocity?": "changeVelocity",
    "4. What is the level of test automation coverage?": "testCoverage",
    "5. What percentage of tests are integrated into CI pipelines?":
      "testsIntegrated",
    "6. Are test quality gates defined as code?": "qualityGates",
    "7. Are test environments ephemeral (auto-provisioned) or manually managed?":
      "testEnv",
    "8. Are pipeline failures automatically triaged?": "pipelineFailures",
    "9. Can developers easily discover, run, and debug tests?": "discoverDebug",
    "10. Is test data provisioning developer-friendly?": "testDataProvisioning",
    "11. Are auto test suggestions available during coding?":
      "autoTestSuggestions",
    "12. Is QE integrated into developer tools (IDE, GitOps)?": "qeIntegration",
    "13. Do teams use self-service platforms for test execution?":
      "selfServicePlatform",
    "14. Are failed tests analyzed for systemic gaps?": "failedTestsAnalysis",
  };

  usePrefillForm(
    dataFromFileUploads,
    questionToFieldMap,
    {
      devOpsMaturity: setDevOpsMaturity,
      ciCdPipeline: setCiCdPipeline,
      testsIntegrated: setTestsIntegrated,
      changeVelocity: setChangeVelocity,
      testCoverage: setTestCoverage,
      qualityGates: setQualityGates,
      testEnv: setTestEnv,
      pipelineFailures: setPipelineFailures,
      discoverDebug: setDiscoverDebug,
      testDataProvisioning: setTestDataProvisioning,
      autoTestSuggestions: setAutoTestSuggestions,
      qeIntegration: setQeIntegration,
      selfServicePlatform: setSelfServicePlatform,
      failedTestsAnalysis: setFailedTestsAnalysis,
    },
    null,
    {
      devOpsMaturity: {
        options: devOpsMaturityOptions,
        setOptions: setDevOpsMaturityOptions,
      },
      testsIntegrated: {
        options: testsIntegratedOptions,
        setOptions: setTestsIntegratedOptions,
      },
    }
  );

  // Select handlers
  const handleDevOpsMaturityChange = (event) => {
    setDevOpsMaturity(event.target.value);
  };

  const handleTestsIntegratedChange = (event) => {
    setTestsIntegrated(event.target.value);
  };

  // Radio handlers
  const handleCiCdPipelineChange = (event) => {
    setCiCdPipeline(event.target.value);
  };

  const handleChangeVelocityChange = (event) => {
    setChangeVelocity(event.target.value);
  };

  const handleTestCoverageChange = (event) => {
    setTestCoverage(event.target.value);
  };

  const handleQualityGatesChange = (event) => {
    setQualityGates(event.target.value);
  };

  const handleTestEnvChange = (event) => {
    setTestEnv(event.target.value);
  };

  const handlePipelineFailuresChange = (event) => {
    setPipelineFailures(event.target.value);
  };

  const handleDiscoverDebugChange = (event) => {
    setDiscoverDebug(event.target.value);
  };

  const handleTestDataProvisioningChange = (event) => {
    setTestDataProvisioning(event.target.value);
  };

  const handleAutoTestSuggestionsChange = (event) => {
    setAutoTestSuggestions(event.target.value);
  };

  const handleQeIntegrationChange = (event) => {
    setQeIntegration(event.target.value);
  };

  const handleSelfServicePlatformChange = (event) => {
    setSelfServicePlatform(event.target.value);
  };

  const handleFailedTestsAnalysisChange = (event) => {
    setFailedTestsAnalysis(event.target.value);
  };

  const handleNext = () => {
    setDevopsTestAutomationAndDeveloperExperience(
      DevOpsTestAutomationAndDeveloperExperienceDataObject
    );
    onNext();
  };

  const handleBack = () => {
    onBack();
  };

  return (
    <Box
      sx={{
        width: {
          xs: "100%", // full width on small screens
          sm: "100%",
          md: "1030px", // fixed width on medium and above
        },
        mx: "auto", // center horizontally
        mt: { xs: 5, sm: 8, md: 3 },
        mb: { xs: 4, md: 6 },
        px: { xs: 2, sm: 3 }, // side padding only for smaller screens
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: { xs: 2, sm: 3, md: 4 },
        }}
      >
        {/* Title */}
      <Typography
          variant="h6"
          sx={{
            fontSize: 20,
            mb: -1,
            position: "relative",
            top: "-14px",
          }}
        >          DevOps, Test Automation & Developer Experience
      </Typography>
      <Box
                sx={{
                  height: {
                    xs: "100%", // full width on small screens
                    sm: "100%",
                    md: "1250px", // fixed width on medium and above
                  },
                }}
              >
        

        <Grid container spacing={3}>
          {/* DevOps maturity level */}
          <Grid item xs={12}>
            <FormControl fullWidth margin="normal" variant="outlined">
              <InputLabel
                shrink
                id="devops-maturity-label"
                sx={{
                  background: "#fff",
                  px: 0.5,
                  mb: 0.5,
                }}
              >
                What is the current DevOps maturity level?
              </InputLabel>
              <Select
                labelId="devops-maturity-label"
                value={devOpsMaturity}
                onChange={handleDevOpsMaturityChange}
                displayEmpty
                renderValue={(selected) => {
                  if (!selected) {
                    return <span style={{ color: "#aaa" }}>Select</span>;
                  }
                  return selected;
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200, // ✅ scrollbar if too tall
                      width: 300,     // ✅ fixed width 300px
                    },
                  },
                  disablePortal: false,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  PopperProps: {
                    modifiers: [
                      {
                        name: "flip",
                        enabled: false,
                      },
                      {
                        name: "preventOverflow",
                        enabled: true,
                        options: {
                          boundary: "viewport",
                        },
                      },
                    ],
                  },
                }}
              >
                {devOpsMaturityOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* CI/CD pipeline */}
          <Grid item xs={12}>
            <FormControl>
              <FormLabel>Is a CI/CD pipeline in place?</FormLabel>
              <RadioGroup
                row
                value={ciCdPipeline}
                onChange={handleCiCdPipelineChange}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
                <FormControlLabel
                  value="Partial"
                  control={<Radio />}
                  label="Partially"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          {/* Change velocity */}
          <Grid item xs={12}>
            <FormControl>
              <FormLabel>What is the typical change velocity?</FormLabel>
              <RadioGroup
                row
                value={changeVelocity}
                onChange={handleChangeVelocityChange}
              >
                <FormControlLabel
                  value="Daily"
                  control={<Radio />}
                  label="Daily"
                />
                <FormControlLabel
                  value="Weekly"
                  control={<Radio />}
                  label="Weekly"
                />
                <FormControlLabel
                  value="Monthly"
                  control={<Radio />}
                  label="Monthly"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          {/* Test automation coverage */}
          <Grid item xs={12}>
            <FormControl>
              <FormLabel>
                What is the level of test automation coverage?
              </FormLabel>
              <RadioGroup
                row
                value={testCoverage}
                onChange={handleTestCoverageChange}
              >
                <FormControlLabel
                  value="None"
                  control={<Radio />}
                  label="None"
                />
                <FormControlLabel
                  value="Partial"
                  control={<Radio />}
                  label="Partial"
                />
                <FormControlLabel
                  value="Full"
                  control={<Radio />}
                  label="Full"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          {/* Tests integrated in CI pipelines */}
          <Grid item xs={12}>
            <FormControl fullWidth margin="normal" variant="outlined" sx={{ position: 'relative', top: '-15px'}}>
              <InputLabel
                shrink
                id="tests-integrated-label"
                sx={{
                  background: "#fff",
                  px: 0.5,
                  mb: 0.5,
                }}
              >
                What percentage of tests are integrated into CI pipelines?
              </InputLabel>
              <Select
                labelId="tests-integrated-label"
                value={testsIntegrated}
                onChange={handleTestsIntegratedChange}
                displayEmpty
                renderValue={(selected) => {
                  if (!selected) {
                    return <span style={{ color: "#aaa" }}>Select</span>;
                  }
                  return selected;
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200, // ✅ scrollbar if too tall
                      width: 300,     // ✅ fixed width 300px
                    },
                  },
                  disablePortal: false,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  PopperProps: {
                    modifiers: [
                      {
                        name: "flip",
                        enabled: false,
                      },
                      {
                        name: "preventOverflow",
                        enabled: true,
                        options: {
                          boundary: "viewport",
                        },
                      },
                    ],
                  },
                }}
              >
                {testsIntegratedOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Test quality gates */}
          <Grid item xs={12}>
            <FormControl sx={{ position: 'relative', top: '-18px'}}>
              <FormLabel>Are test quality gates defined as code?</FormLabel>
              <RadioGroup
                row
                value={qualityGates}
                onChange={handleQualityGatesChange}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
                <FormControlLabel
                  value="Partially"
                  control={<Radio />}
                  label="Partially"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          {/* Test environments */}
          <Grid item xs={12}>
            <FormControl sx={{ position: 'relative', top: '-20px'}}>
              <FormLabel>
                Are test environments ephemeral (auto-provisioned) or manually
                managed?
              </FormLabel>
              <RadioGroup row value={testEnv} onChange={handleTestEnvChange}>
                <FormControlLabel
                  value="ephemeral"
                  control={<Radio />}
                  label="Ephemeral (auto-provisioned)"
                />
                <FormControlLabel
                  value="manual"
                  control={<Radio />}
                  label="Manually managed"
                />
                <FormControlLabel
                  value="hybrid"
                  control={<Radio />}
                  label="Hybrid"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl sx={{ position: 'relative', top: '-23px'}}>
              <FormLabel>
                Are pipeline failures automatically triaged?
              </FormLabel>
              <RadioGroup
                row
                value={pipelineFailures}
                onChange={handlePipelineFailuresChange}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
                <FormControlLabel
                  value="Partially"
                  control={<Radio />}
                  label="Partially"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          {/* Change velocity */}
          <Grid item xs={12}>
            <FormControl sx={{ position: 'relative', top: '-25px'}}>
              <FormLabel>
                Can developers easily discover, run, and debug tests?
              </FormLabel>
              <RadioGroup
                row
                value={discoverDebug}
                onChange={handleDiscoverDebugChange}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
                <FormControlLabel
                  value="Partially"
                  control={<Radio />}
                  label="Partially"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          {/* Test automation coverage */}
          <Grid item xs={12}>
            <FormControl sx={{ position: 'relative', top: '-25px'}}> 
              <FormLabel>
                Is test data provisioning developer-friendly?
              </FormLabel>
              <RadioGroup
                row
                value={testDataProvisioning}
                onChange={handleTestDataProvisioningChange}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
                <FormControlLabel
                  value="Partially"
                  control={<Radio />}
                  label="Partially"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          {/* CI/CD pipeline */}
          <Grid item xs={12}>
            <FormControl sx={{ position: 'relative', top: '-25px'}}>
              <FormLabel>
                Are auto test suggestions available during coding?
              </FormLabel>
              <RadioGroup
                row
                value={autoTestSuggestions}
                onChange={handleAutoTestSuggestionsChange}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl sx={{ position: 'relative', top: '-25px'}}>
              <FormLabel>
                Is QE integrated into developer tools (IDE, GitOps)?
              </FormLabel>
              <RadioGroup
                row
                value={qeIntegration}
                onChange={handleQeIntegrationChange}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
                <FormControlLabel
                  value="Partially"
                  control={<Radio />}
                  label="Partially"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl sx={{ position: 'relative', top: '-25px'}}>
              <FormLabel>
                Do teams use self-service platforms for test execution?
              </FormLabel>
              <RadioGroup
                row
                value={selfServicePlatform}
                onChange={handleSelfServicePlatformChange}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
                <FormControlLabel
                  value="Partially"
                  control={<Radio />}
                  label="Partially"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl sx={{ position: 'relative', top: '-25px'}}>
              <FormLabel>
                Are failed tests analyzed for systemic gaps?
              </FormLabel>
              <RadioGroup
                row
                value={failedTestsAnalysis}
                onChange={handleFailedTestsAnalysisChange}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
                <FormControlLabel
                  value="Sometimes"
                  control={<Radio />}
                  label="Sometimes"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
        </Box>
      </Paper>

      {/* Buttons outside Paper */}
      <QEStrategyCommonButton handleBack={handleBack} handleNext={handleNext} />
    </Box>
  );
};

export default DevOpsTestAutoDeveloperExperience;
